import { 
    FETCH_SUBJECTS,
    NEW_SUBJECT,
    URL 
} from './types';

export const fetchSubjects = (token) => dispatch => {
    fetch(URL + 'api2/subjects/', {
        headers: new Headers({
            'Authorization': 'JWT ' + token,
            'content-type': 'application/json'
        })
    })
    .then(res=>res.json())
    .then(subjects=>
        dispatch({
            type: FETCH_SUBJECTS,
            payload: subjects
        })  
    )
}

export const newSubject = (token, subject) => dispatch => {
    fetch(URL + 'api2/subjects/', {
        method: 'POST',
        headers: new Headers({
            'Authorization': 'JWT ' + token,
            'content-type': 'application/json'
        }),
        body: JSON.stringify({'name': subject})
    })
    .then(res=>res.json())
    .then(result=>
      dispatch({
          type: NEW_SUBJECT,
          payload: result
      })
  );
}


// WEBPACK FOOTER //
// ./src/actions/subjectActions.js